module.exports = __webpack_public_path__ + "img/option_two.34d26c3d.png";